import { Box, Button, CircularProgress, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FC, ReactNode } from 'react';
import { useCompanyNavigate, useContainerWidth } from '@lendica/hooks';

interface SidePanelLayoutProps {
    children: ReactNode;
    loading?: boolean;
    redirectRoute: string;
    collapsible?: boolean;
}

export const CircularIndeterminate = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#9292a4',
            }}
        >
            <CircularProgress color="inherit" />
        </Box>
    );
};

export const SidePanelLayout: FC<SidePanelLayoutProps> = ({
    children,
    loading,
    redirectRoute,
    collapsible,
}) => {
    const navigate = useCompanyNavigate();
    const { isNarrow } = useContainerWidth();

    const handleClose = () => navigate(redirectRoute);

    if (isNarrow) {
        return (
            <Dialog
                fullScreen
                open={true}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: 'background.default',
                    },
                }}
            >

                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <IconButton
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ overflow: 'auto', height: '100%', p: 2 }}>
                    {loading ? <CircularIndeterminate /> : children}
                </Box>
            </Dialog>
        );
    }

    return (
        <Box
            sx={{
                py: 2,
                px: 4,
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minWidth: 300,
                boxSizing: 'border-box',
            }}
            className={`aside ${collapsible ? 'collapsible' : ''}`}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    pb: 1,
                }}
            >
                <Button onClick={handleClose}>Close</Button>
            </Box>
            {loading ? <CircularIndeterminate /> : children}
        </Box>
    );
};
